import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  CommonReducerAction,
  setHelperText,
} from "../../../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../../../Actions/LanguageAction";
import CarryForwardEncashment from "../Common/CarryForwardEncashment";
import ClubLeave from "../Common/ClubLeave";
import GiftALeave from "../Common/GiftALeave";
import ProRate from "../Common/ProRate";
import SandwichLeave from "../Common/SandwichLeave";
import UsagePolicy from "../Common/UsagePolicy/index";
import LeaveBalanceAvailable from "../CustomLeave/LeaveBalanceAvailable";
import { Validation } from "../../Validation";
import LeaveApplication from "../Common/LeaveApplication";
import NameLeaveAllocation from "./NameLeaveAllocation";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});
class VacationLeave extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ParentIndex: props.ParentIndex || 0,
      leavetypeid: props.leavetypeid,
      notUnique: false,
    };

    this.onBeforeUpload = this.onBeforeUpload.bind(this);
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);
    this.props.onRef({
      onNext: this.validateNext,
    });
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  componentWillReceiveProps(props) {
    this.props.onRef({
      onNext: this.validateNext,
    });
    if (this.state.ParentIndex != props.ParentIndex) {
      window.scrollTo(0, 0);
      this.setState({ ParentIndex: props.ParentIndex });
    }
    if (this.state.leavetypeid != props.leavetypeid) {
      this.setState({ leavetypeid: props.leavetypeid });
    }
  }

  validateNext = () => {
    const [isError, errorMessage] = Validation(
      this.state.leavetypeid,
      this.state.ParentIndex,
    );
    if (!isError) {
      this.props.click();
    } else {
      this.props.enqueueSnackbar(errorMessage, { variant: "error" });
    }
  };

  render() {
    const { InitLeavesPolicy } = this.props;
    const language = this.props.Language.extratimepolicy;
    return (
      <IntlProvider locale="en" messages={language}>
        <Grid container>
          <Grid item xs={12} md={12} sm={12}>
            <div
              className={classNames(
                InitLeavesPolicy.isviewmode
                  ? "disable-leavepolicy padding-bottom-30 leave_policy_form"
                  : "padding-bottom-30 leave_policy_form",
              )}
            >
              <NameLeaveAllocation
                ChangeSteppername={this.props.ChangeSteppername}
                ParentIndex={this.state.ParentIndex}
                leavetypeid={this.state.leavetypeid}
              />
              <ProRate
                ParentIndex={this.state.ParentIndex}
                leavetypeid={this.state.leavetypeid}
              />
              <LeaveBalanceAvailable
                ParentIndex={this.state.ParentIndex}
                leavetypeid={this.state.leavetypeid}
              />
              <UsagePolicy
                ParentIndex={this.state.ParentIndex}
                leavetypeid={this.state.leavetypeid}
              />
              <SandwichLeave
                ParentIndex={this.state.ParentIndex}
                leavetypeid={this.state.leavetypeid}
              />
              <ClubLeave
                ParentIndex={this.state.ParentIndex}
                leavetypeid={this.state.leavetypeid}
              />
              <LeaveApplication
                ParentIndex={this.state.ParentIndex}
                leavetypeid={this.state.leavetypeid}
              />
              <CarryForwardEncashment
                ParentIndex={this.state.ParentIndex}
                leavetypeid={this.state.leavetypeid}
              />
              <GiftALeave
                ParentIndex={this.state.ParentIndex}
                leavetypeid={this.state.leavetypeid}
              />
              {/* {this.state.ParentIndex
              != this.props.InitLeavesPolicy.details.length - 1 ? (
                <Button
                  className="margin-top-30"
                  variant="contained"
                  color="primary"
                  onClick={() => this.validateNext()}
                >
                  Next
                </Button>
              ) : (
                ""
              )} */}
            </div>
          </Grid>
        </Grid>
      </IntlProvider>
    );
  }
}
VacationLeave.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitLeavesPolicy: state.InitLeavesPolicy,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(VacationLeave)));
